// extracted by mini-css-extract-plugin
module.exports = {"root":"ResumeHistory_root__NjLtC","item":"ResumeHistory_item__3kTJ1","header":"ResumeHistory_header__2zKXa","company":"ResumeHistory_company__25E-K"};